import { memoizr }                from '../../../reduxion-core/lib'
import * as transform             from '../../lib/transform'
import actionTypes                from '../../constants/actionTypes'
import { getHost, getQueryString, getLeagues }  from './index'
import StandingConfig             from '../../components/standings/config'
import selectn                    from 'selectn'

/**
 * Gets the first league from the league api if no league supplied in URL
 *
 * @param  {Object}   params      Router params
 * @param  {Object}   res     Complete API return value
 * @return {Object}               Action
 **/
function getLeagueId( params = {}, res = {} ) {

  let leagueId = params.league || ''

  if ( !leagueId ) {
    const leagues = selectn('data.leagues', res) || []

    for( let league of leagues ) {
      if ( league.hasStandings === true ) {
        if ( params.sport === 'cricket' ) {
          leagueId = league.id || ''
        }else{
          leagueId = league.midsizeName || ''
        }
        break
      }
    }
  }

  return leagueId.toLowerCase() || ''
}

/**
 * action to get standings
 *
 * @param  {Object}   edition     Edition config
 * @param  {Object}   params      Router params
 * @param  {Object}   location    Router location
 * @param  {Object}   config    Config values
 * @return {Object}               Action
 **/
function getStandings({ edition = {}, params = {}, location = {}, config = { parameters: {} }, appProps }) {

  let queryObject = {
    sort :      config.parameters.sort && `${config.parameters.sort}:${config.parameters.dir || 'asc'}` || false ,
    seasontype :  config.parameters.seasontype || 1,
    type :      0
  }

  if ( params.season ) {
    queryObject.season = params.season
  }

  const url = `${params.origin || getHost('site', '', appProps)}/apis/v2/sports/${params.sport}/${params.league}/standings${getQueryString(queryObject, edition, params)}`

  return {
    url,
    edition,
    location,
    params,
    type: actionTypes.GET_STANDINGS,
    promise: memoizr.get(url),
    transform: transform.onGetStandings
  }
}

/**
 * An Example of calling multiple APIs
 * in series having dependencies
 *
 * @param  {Object}   edition     Edition config
 * @param  {Object}   params      Params
 * @param  {Object}   location    Router location
 * @return {Function}             Handled by thunk middleware
 **/
export default function getStandingsPage({ edition = {}, params = {}, location = {}, appProps = {} }) {

  //console.log('fetching standings page')

  /* load in the config for standings */
  const config = StandingConfig.get({
    sport : params.sport,
    root :  params.sport,
    page :  params.pageType,
    params
  })

  /* copy params so we can overwrite league id */
  let routeParams     = Object.assign( {}, params )
  let leagueResults     = {}
  let standingsResults  = {}
  let leaguesAction
  let standingsAction

  return ( dispatch ) => {

    const loadLeagueList = function () {

      //console.log('fetching league list')

      leaguesAction = getLeagues({ edition, params: routeParams, location, appProps })

      return leaguesAction.promise
        .then( res => {

          //console.log('fetched league list')

          routeParams.league = getLeagueId( routeParams, res )

          leagueResults = res || {}

          return res

        })
    }

    const loadStandings = function () {

      //console.log('fetching standings')

      standingsAction = getStandings({ edition, params: routeParams, location, config, appProps })

      return standingsAction.promise
        .then( res => {

          //console.log('fetched standings')

          standingsResults = res || {}

          return res

        })

    }

    const dispatchResult = function () {
      const url = [ leaguesAction.url, standingsAction.url ]
      dispatch({
        data :    transform.onGetStandings({ res: standingsResults, leagueRes: leagueResults, edition, params: routeParams, location, appProps }),
        type :    actionTypes.GET_STANDINGS,
        url  :    url
      })
    }

    const standingsFailure = function ( error ) {
      console.log(error)
      //dispatch( getErrorRedirect( routeParams ) )
    }

    if ( config.showLeagueDropdown ) {
      if ( !routeParams.league ) {
        return loadLeagueList()
          .then( loadStandings )
          .then( dispatchResult )
          .catch( standingsFailure )
      }else{
        return Promise.all( [ loadStandings(), loadLeagueList() ] )
          .then( dispatchResult )
          .catch( standingsFailure )
      }
    }

    return loadStandings()
      .then( dispatchResult )
      .catch( standingsFailure )

  }
}



// WEBPACK FOOTER //
// ../app/actions/api/standings.js